module.exports = __webpack_public_path__ + "f4f17fd53c7d040e56f91a3ecb692b22.woff2";